import React, { Component } from "react";
import PropTypes from "prop-types";
import Ad from "components/Library/Ad";

if (typeof window !== "undefined") {
  import("lazysizes");
}

class StreamAd extends Component {
  constructor(props) {
    super(props);
    this.onLazyload = this._onLazyload.bind(this);

    // Don't lazyload (read; automatically load) the first ad. props.advert.index is 1-indexed.
    this.state = { shouldLoad: (props.advert.index === 1) };
  }

  componentDidMount() {
    document.addEventListener("lazybeforeunveil", this.onLazyload);
  }

  componentWillUnmount() {
    document.removeEventListener("lazybeforeunveil", this.onLazyload);
  }

  _onLazyload(e) {
    if (this.node === e.target) {
      this.setState({ shouldLoad: true });
    }
  }

  render() {
    return (
      <div className="lazyload advert-card" data-expand="1000" ref={(node) => this.node = node}>
        {this.state.shouldLoad && <Ad
          adUnit={this.props.stream}
          slotSize="fluid"
          renderWhenViewable={false}
          collapseEmptyDiv={true}
          targeting={{
            "s1": this.props.stream,
            "pos": `mid${this.props.advert.index}`,
            "pid": this.props.advert.postIds,
            "kw-before": this.props.advert.beforeTags,
            "kw-after": this.props.advert.afterTags,
            "adid": this.props.adId || "",
          }}
        />}
      </div>
    );
  }
}

StreamAd.propTypes = {
  advert: PropTypes.object.isRequired,
  stream: PropTypes.string.isRequired,
  adId: PropTypes.string,
};

export default StreamAd;
